import { CancelPolicyRule } from "@graphql/types";
import { t } from "@helpers/translate";

const getCancellationTime = (
  cancelPolicyRules?: CancelPolicyRule[]
): string => {
  let days = 0;
  if (!!cancelPolicyRules && cancelPolicyRules.length) {
    days = cancelPolicyRules[cancelPolicyRules.length - 1].to + 1;
  }

  if (days === 0) {
    return "";
  }

  if (days <= 2) {
    const hours = days * 24;
    return t({
      id: "tour.sidebar.cancellation-hours",
      message: `FREE cancellation ${hours} hours prior`,
      values: {
        hours: `${hours}`,
      },
    });
  }
  if (days > 2) {
    return t({
      id: "tour.sidebar.cancellation-days",
      message: `FREE cancellation ${days} days prior`,
      values: {
        days: `${days}`,
      },
    });
  }
  return "";
};

export default getCancellationTime;
